module.exports = __webpack_public_path__ + "img/ludinam_2019.d39e293f.png";